import "./src/styles/globals.css"
import { captureAttribution, trackFunnel } from "./src/lib/funnel"

export const onRouteUpdate = ({ location }) => {
  captureAttribution()
  if (!sessionStorage.getItem("ue_landed_tracked")) {
    sessionStorage.setItem("ue_landed_tracked", "1")
    trackFunnel("landed", { path: location.pathname })
  }
  if (location.pathname === "/pricing" || location.pathname === "/pricing/") {
    trackFunnel("pricing_viewed", { surface: "marketing" })
  }
}
